"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _json = _interopRequireDefault(require("highlight.js/lib/languages/json"));

var _default = _json["default"];
exports["default"] = _default;